module.exports = __webpack_public_path__ + "static/media/next-video-disabled-icon.520c2217.svg";